<template>
    <section>
        <navigation></navigation>
        <h5 class="center-align">Home</h5>

<img src="https://lh3.googleusercontent.com/CTecpdrBd_XlXZDIjg7Si6weL8zdlYH1Gt-QnuTu7m678VMgY8I_oxFw9gVq0vEXGcceTXUlseCMl_K0oodFvLg44DFp41le_zC_UwsKOSoEyusu5OBVHR9ddqF_IOWI5y0Fn9HoZn6vn7Wtj1eU3J4emLJ2o5oKIqt52lQLyoELwHM7WOqNv3LZuXS_nMfP_YE7HCwBNf8QbdQeBIOghoROq0GaMef0wptAdttIBLBpP8QSnBVbCbaDgPoncEIrb7ST1EnvmO7qSWSP_TS-TblC2VU1FFqC4h5nuVgphx2y_5wuAOZwRqLskUhvFSeXemLUKNvv58kRiOpCtsDdTDS8KNMrleKaYjY_IiqmdHsieyf2mJPejhLFTvc4RvJu-pp__o0mkxJDe_IMDWyfSMvH3Ru_abJGQmpzy1pnEbEPFL4-M8gAY_j7MLnd5EQmljAm1y0OQqzdNdKlCOWUixpo3kTCvmgp00QLIcd7UjsL4nNUH3KA57ozPigGbsr_xkx-EC_D7SkX5HwDVkAZAy1B9_Z2uTO0dH3_2FaY_Lqjy41gXvGyOFMgmI-MbhRG1soLWl9fAsILCO-Dcfixsh-ZFqpFO2uvgU94R-BZFfJnoR-bO5uoImL0DYmJX3IPWmbleKg--VpGYmSOCsgYaY19_uBp1mg0Q3xfsZXFHnCNpuz0mfYOi7PERtk9vw=w1032-h774-no?authuser=0">

    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";

export default {
    data() {
        return {};
    },
    components: {
        navigation
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue